import React from 'react';
import PropTypes from 'prop-types';

const Address = ({
	name,
	address1,
	city,
	state,
	postalCode,
	url,
	addressClasses
}) => {
	const addressArray = [
		{
			key: 'address',
			content: address1,
			className: 'street-address d-block'
		},
		{
			key: 'city',
			content: city,
			className: 'locality'
		},
		{
			key: 'separator',
			content: ', ',
			className: 'separator'
		},
		{
			key: 'state',
			content: `${state} `,
			className: 'region'
		},
		{
			key: 'zipCode',
			content: postalCode,
			className: 'postal-code'
		}
	];

	return (
		<address className={`vcard ${addressClasses}`}>
			<p className="fn n mb-0">
				<strong className="org">{name}</strong>
			</p>
			{url && (
				<a target="_blank" rel="noopener noreferrer" href={url.link}>
					{url.text}
				</a>
			)}
			<p className="adr">
				{addressArray.map(({ key, content, className }) => (
					<span key={key} className={className}>
						{content}
					</span>
				))}
			</p>
		</address>
	);
};

export default Address;

Address.propTypes = {
	name: PropTypes.string.isRequired,
	address1: PropTypes.string.isRequired,
	city: PropTypes.string.isRequired,
	state: PropTypes.string.isRequired,
	postalCode: PropTypes.string.isRequired,
	addressClasses: PropTypes.string.isRequired,
	url: PropTypes.shape({
		link: PropTypes.string,
		text: PropTypes.string
	})
};

Address.defaultProps = {
	url: null
};



// WEBPACK FOOTER //
// ./src/components/Address.jsx